import { Image } from '@weareconceptstudio/core';

//* Style
import LogoStyle from './style';

const Logo = ({ type = 'header', className }) => {
	return (
		<LogoStyle className={className || ''}>
			<div className={`inner-wrapper-logo ${type}`}>
				<Image
					src={'/images/logo.svg'}
					alt={'logo'}
				/>
			</div>
		</LogoStyle>
	);
};

export default Logo;
